import { render, staticRenderFns } from "./atribuicao-estrategia.vue?vue&type=template&id=2b02e176&scoped=true&"
import script from "./atribuicao-estrategia.vue?vue&type=script&lang=js&"
export * from "./atribuicao-estrategia.vue?vue&type=script&lang=js&"
import style0 from "./atribuicao-estrategia.vue?vue&type=style&index=0&id=2b02e176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02e176",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
